import { RECHTENSOORTEN, RECHTEN_LABEL, type Rechten } from '@vip/shared';

import { Badge } from '@/components/ui/badge';

/**
 * Wat iemand mag, als tag.
 *
 * Dit was één tag, omdat rechten één trap waren en wie beheerde gewoon
 * Admin was. Nu zijn buddy, Core Team en Admin losse vinkjes en kan
 * iemand er meer hebben, dus staan er zo nodig meer tags. Eén samengestelde tag
 * zou een categorie suggereren die niet bestaat. View Only staat er nooit naast:
 * dat vinkje sluit de andere drie uit.
 *
 * De Admin krijgt de opvallende variant en wie niets heeft de enige lege.
 * Gevuld betekent dus: komt binnen. Op een scherm dat over toegang gaat wil je
 * dat in één blik zien; welke van de drie het is leest het woord erin.
 *
 * De volgorde is dezelfde als in het vinkjesvenster, want hij komt uit
 * `RECHTENSOORTEN`. Eén volgorde door de hele app scheelt het omdenken bij elke
 * lijst.
 *
 * De tags komen los terug en niet in een omhulsel eromheen. Met een eigen
 * omhulsel had die groep zijn eigen tussenruimte, en dan staan de tags dichter
 * op elkaar dan op de tags ernaast. Elke plek waar dit staat is een rij die zijn
 * eigen ruimte al verdeelt.
 */
const VARIANT = {
  buddy: 'secondary',
  coreTeam: 'secondary',
  admin: 'default',
  viewOnly: 'secondary',
} as const;

export function RechtenBadge({ rechten }: { rechten: Rechten }) {
  const heeft = RECHTENSOORTEN.filter((soort) => rechten[soort]);
  if (heeft.length === 0) return <Badge variant="outline">Geen</Badge>;

  return (
    <>
      {heeft.map((soort) => (
        <Badge key={soort} variant={VARIANT[soort]}>
          {RECHTEN_LABEL[soort]}
        </Badge>
      ))}
    </>
  );
}
